import CreditNoteCreateContainer from "@legacy/credit_notes/CreditNoteCreateContainer"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

import { CREDIT_NOTES_ROUTES } from "@routes/creditNotes"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function CreditNoteEdit() {
    const creditNoteId = window.CREDIT_NOTE_ID
    const isDraft = window.CREDIT_NOTE_IS_DRAFT

    const [detailsRoute] = useSlugExtractor([CREDIT_NOTES_ROUTES.DETAILS], creditNoteId)
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const detailsBackDestination = hasPermission("invoices_view_permission", PERMISSION_LEVEL.FULL)
        ? detailsRoute
        : undefined

    return (
        <AppFrame.Root pageId="CreditNoteEdit" navigationType="inner">
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageInnerTitle
                            label={isDraft ? "New Credit Note" : "Edit Credit Note"}
                            backDestination={detailsBackDestination}
                        />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <CreditNoteCreateContainer formMode="EDIT_CREDIT_NOTE" addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
